import moment from "moment";
import Link from "next/link";

type GameType = {
    date?: Date|null
    type?: string
    use?: string
    children?: any
}

export default function Game({date, type = 'game', use, children}: GameType) {
    let startsSoon = false;
    const dateObj = moment(date).subtract();
    if (date && dateObj.diff(moment(), 'hours') < 22 && dateObj.isAfter(moment())) {
        startsSoon = true;
    }
    return (
        <div className={`eo-game typ-${type} use-${use} ${startsSoon ? 'm-startsSoon' : ''}`}>
            {startsSoon && use === 'hero' && (
                <div className="game-startsSoon">
                    Starts in {dateObj.toNow(true)}
                </div>
            )}
            {children}
        </div>
    )
}
